function getCookie(name: string): string | undefined {
  if (typeof document === "undefined") return undefined;
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : undefined;
}

interface CAPIEventOptions {
  event_name: string;
  event_id: string;
  event_source_url?: string;
  user_data?: {
    em?: string;
    ph?: string;
    fn?: string;
    ln?: string;
    external_id?: string;
    fbc?: string;
    fbp?: string;
  };
  custom_data?: Record<string, unknown>;
}

export async function sendCAPIEvent(options: CAPIEventOptions): Promise<void> {
  const { event_name, event_id, event_source_url, user_data = {}, custom_data } = options;

  const fbc = user_data.fbc ?? getCookie("_fbc");
  const fbp = user_data.fbp ?? getCookie("_fbp");

  try {
    await fetch(`${process.env.NEXT_PUBLIC_HOSTNAME}/meta/capi/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        event_name,
        event_id,
        event_source_url,
        user_data: { ...user_data, fbc, fbp },
        custom_data,
      }),
    });
  } catch (error) {
    console.warn("[Meta CAPI] Failed to send event:", error);
  }
}
